import React from "react";
import { PageLayout } from "../common/layout";
import { ComingSoon } from "../common/components";

// Página custom. Llenala en develop; el merge base→develop preserva tus cambios.
export const OnisPage = () => {
  return (
    <PageLayout>
      <ComingSoon
        title="ONIs"
        description="Obras no identificadas por SADAIC que podrían pertenecer a tu repertorio."
      />
    </PageLayout>
  );
};
